import { jsx as s } from "react/jsx-runtime";
import { forwardRef as t } from "react";
import { makeClassesByStyles as e } from "../../../../utils/classes.js";
import m from "../../../../assets/8fc7e08e.modal-backdrop.module.css";
const d = e(m), f = t(
  ({ className: o, handleClick: r }, a) => /* @__PURE__ */ s(
    "div",
    {
      ref: a,
      "aria-hidden": "true",
      className: d("ModalBackdrop", o),
      onClick: r
    }
  )
);
export {
  f as ModalBackdrop
};
